module.exports = __webpack_public_path__ + "clinic.ddae0b1f71dc0a564cfc.eot";


//////////////////
// WEBPACK FOOTER
// D:/My Projects/2023/eCompound/unimas-request-web/src/assets/fonts/clinic.eot
// module id = ../../../../../src/assets/fonts/clinic.eot
// module chunks = styles